import type { FC } from "react";

import classNames from "classnames";

import { Skeleton } from "@jti/core-components/components/Skeleton";

import formStyles from "../../SecuredFieldsForm.module.scss";
import styles from "./SecuredFieldsFormSkeleton.module.scss";

const FieldSkeleton = ({ className }: { className?: string }) => (
  <div className={classNames(styles.field, className)}>
    <Skeleton height="var(--des-font-text-text-2xs-line-height)" />
    <Skeleton height="var(--des-dimension-height-and-width-control-medium)" />
  </div>
);

export const SecuredFieldsFormSkeleton: FC = () => (
  <div className={styles.container} data-testid="secured-fields-skeleton">
    <FieldSkeleton />
    <div className={formStyles.expiryRow}>
      <FieldSkeleton className={formStyles.expiryRowItem} />
      <FieldSkeleton className={formStyles.expiryRowItem} />
    </div>
    <FieldSkeleton />
    <FieldSkeleton />
  </div>
);
